import { takeLatest, put, call } from 'redux-saga/effects';

import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {
  DOCUMENT_DELETE,
  DOCUMENT_DETAILS_GET,
  DOCUMENTS_CATEGORIES_GET,
  DOCUMENTS_LIST_GET,
} from '../actions/documents';
import documents from '../../api/documents';
import { errorHandling } from '../../../utils/errors';

function* documentsListGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      documents.documentsListGet,
      {
        filters,
      }
    );
    yield put({ type: DOCUMENTS_LIST_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documents > documentsListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentsListGetWatch() {
  yield takeLatest(DOCUMENTS_LIST_GET._REQUEST, documentsListGet);
}

function* documentDetailsGet({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      documents.documentDetailsGet,
      {
        id,
      }
    );
    yield put({ type: DOCUMENT_DETAILS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documents > documentDetailsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentDetailsGetWatch() {
  yield takeLatest(DOCUMENT_DETAILS_GET._REQUEST, documentDetailsGet);
}

function* documentCategoriesGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      documents.documentCategoriesGet
    );
    yield put({ type: DOCUMENTS_CATEGORIES_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documents > documentCategoriesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentCategoriesGetWatch() {
  yield takeLatest(DOCUMENTS_CATEGORIES_GET._REQUEST, documentCategoriesGet);
}

function* documentDelete({ id, callback, published }) {
  try {
    yield put({ type: LOADER_OPEN });
    yield call(documents.documentDelete, id, published);
    yield put({ type: DOCUMENT_DELETE._SUCCESS });
    if (typeof callback === 'function') yield callback();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > documents > documentDelete', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* documentDeleteWatch() {
  yield takeLatest(DOCUMENT_DELETE._REQUEST, documentDelete);
}

export default [
  documentsListGetWatch(),
  documentDetailsGetWatch(),
  documentCategoriesGetWatch(),
  documentDeleteWatch(),
];
